import resume from '../assets/pdf/resume.pdf'
import  Avijit  from '../jpg/Avijit.jpeg'
export const headerData = {
    name: 'Avijit Ghosh',
    title: "Software Developer",
    desciption:"Full-stack web developer with a specialization in front-end and back-end web development,Blockchain and Cryptocurrency Adaptable to new technology to enhance my skills and capabilities.",
    image: Avijit,
    resumePdf: resume
}
